import { Spinner, SpinnerSize } from "@fluentui/react";
import { useGetAfterActionReportDocument } from "#root/queries/afterActionReport";
import { Button } from "@fluentui/react-components";
import { ArrowDownloadFilled } from "@fluentui/react-icons";

export const DownloadReportButton: React.FC<{ reportId: string }> = ({ reportId }) => {
  const { refetch, isFetching } = useGetAfterActionReportDocument(reportId);
  const handleDownload = () => {
    if (!isFetching) {
      refetch();
    }
  };
  return (
    <Button
      icon={isFetching ? <Spinner size={SpinnerSize.small} /> : <ArrowDownloadFilled />}
      appearance="subtle"
      title={`Download report with ID = ${reportId}`}
      onClick={handleDownload}
      disabled={isFetching}
    />
  );
};